import React from "react";
import { X } from "react-feather";
import "./styles.scss";

const InputErrorMessage = ({ message, onClear }) => (
  <div className="validation-error">
    <div className="message">{message}</div>
    {onClear && (
      <X
        data-testid="close-button"
        className="close-button"
        size={16}
        onClick={onClear}
      />
    )}
  </div>
);

export default InputErrorMessage;
